/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

class Tabs extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { children, onChange } = this.props;
    return (
      <div className="tabs">
        {children &&
          children.length > 0 &&
          children.map(child => {
            const { props } = child;
            return (
              <React.Fragment key={props.label}>
                <input
                  type="radio"
                  checked={props['data-active']}
                  name="tab"
                  id={`tab${props.label}`}
                  onChange={() => {
                    onChange(props.label);
                  }}
                />
                <label
                  htmlFor={`tab${props.label}`}
                  onClick={e => {
                    e.target.previousSibling.checked = true;
                    onChange(props.label);
                  }}
                >
                  {props.label}
                </label>
              </React.Fragment>
            );
          })}
        {children && children}
      </div>
    );
  }
}
Tabs.defaultProps = {
  onChange: () => {},
  children: null
};
Tabs.propTypes = {
  onChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default Tabs;
